import { GrcNotify, NotifyType } from '@grc/ui-package';
import notify from '../../common/notify';

export const getTrackedTransportationDetailsById = async (
  url: string,
  fetchData: any,
  trackingService: any
): Promise<{}> => {
  try {
    const response: any = await fetchData(url, notify, trackingService);

    if (response.status === 200 && response.data) {
      return response.data;
    }

    return {};
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return {};
  }
};
